import { createContext, useContext } from "react";

export const AssistantViewContextRegistry = createContext(null);
export const AssistantScappContextRegistry = createContext(null);
export const AssistantNanooxContextRegistry = createContext(null);

export function useAssistantViewRegistry() {
  return useContext(AssistantViewContextRegistry);
}

export function useAssistantScappRegistry() {
  return useContext(AssistantScappContextRegistry);
}

export function useAssistantNanooxRegistry() {
  return useContext(AssistantNanooxContextRegistry);
}
